export enum FilterModelType {
  TEXT,
  NUMBER,
  DATE,
  BOOLEAN,
  SET,
  MULTI
}
